import ApiService from '../api.service';
import { unwrapData } from '../../utils/apiConvert';

const URL = '/api/users/me/favourite-reports';

export const reportFavouritesService = {
  get: async () => unwrapData(await ApiService.get(URL))?.reports || [],
  save: async (reports) => unwrapData(await ApiService.put(URL, { reports }))?.reports || [],
};
